<template>
  <section id="wrapper" class="error-page">
    <div class="error-box">
      <div class="error-body text-center">
        <h1 class="text-info">Network</h1>
        <h3 class="text-uppercase">通信が失敗しました。</h3>
        <p class="text-muted m-t-30 m-b-30">通信環境が不安定です。時間をおいてもう一度お試しください</p>
        <a href="/" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">ホームへ戻る</a>
      </div>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>

</style>
